import React from 'react';
import PropTypes from 'prop-types';
import * as colors from 'material-ui/styles/colors';
import FloatingActionButton from 'material-ui/FloatingActionButton';

const themes = [
    {
        theme: {
            palette: {
                primary1Color: colors.red500,
                primary2Color: colors.red700
            }
        },
        key: 'redTheme'
    }, {
        theme: {
            palette: {
                primary1Color: colors.blue500,
                primary2Color: colors.blue700

            }
        },
        key: 'blueTheme'
    }, {
        theme: {
            palette: {
                primary1Color: colors.green500,
                primary2Color: colors.green700
            }
        },
        key: 'greenTheme'
    }, {
        theme: {
            palette: {
                primary1Color: colors.deepOrange500,
                primary2Color: colors.deepOrange700
            }
        },
        key: 'orangeTheme'
    }, {
        theme: {
            palette: {
                primary1Color: colors.blueGrey500,
                primary2Color: colors.blueGrey700
            }
        },
        key: 'blueGreyTheme'
    }, {
        theme: {
            palette: {
                primary1Color: colors.cyan500,
                primary2Color: colors.cyan700
            }
        },
        key: 'cyanTheme'
    }, {
        theme: {
            palette: {
                primary1Color: colors.indigo500,
                primary2Color: colors.indigo700
            }
        },
        key: 'indigoTheme'
    }, {
        theme: {
            palette: {
                primary1Color: colors.brown500,
                primary2Color: colors.brown700
            }
        },
        key: 'brownTheme'
    }, {
        theme: {
            palette: {
                primary1Color: colors.grey500,
                primary2Color: colors.grey700
            }
        },
        key: 'greyTheme'
    }, {
        theme: {
            palette: {
                primary1Color: colors.purple500,
                primary2Color: colors.purple700

            }
        },
        key: 'purpleTheme'
    }, {
        theme: {
            palette: {
                primary1Color: colors.deepPurple500,
                primary2Color: colors.deepPurple700

            }
        },
        key: 'deepPurpleTheme'
    }
];

const ThemeSelector = (props) => {

    const {siteActions} = props;
    const themeButtons = [];
    themes.forEach((config, index) => {
        themeButtons.push(<FloatingActionButton
            key={index}
            onTouchTap={() => siteActions.setTheme(config.theme)}
            backgroundColor={config.theme.palette.primary1Color}
            mini={true}/>);
    });

    return (
        <div>
            {themeButtons}
        </div>
    );
};

ThemeSelector.propTypes = {
    siteActions: PropTypes.object.isRequired
};

export default ThemeSelector;



// WEBPACK FOOTER //
// ./src/components/layout/ThemeSelector.js